// extracted by mini-css-extract-plugin
export default {"searchArea":"search_searchArea_hFvvG","mobileSearchBar":"search_mobileSearchBar_umDIv"};